export default __webpack_public_path__ + "static/media/Blanket2.c78e591c.png";